import { Link, useLocation } from 'react-router-dom';
import { BookOpen, Building2, GitBranch, Info, Package } from 'lucide-react';
import { NAV_ITEMS, ROUTES } from '@/utils/constants';
import { cn } from '@/utils';

const TAB_ICONS = {
  [ROUTES.INDUSTRIES]: Building2,
  [ROUTES.PRODUCTS]: Package,
  [ROUTES.KNOWLEDGE]: BookOpen,
  [ROUTES.WORKFLOWS]: GitBranch,
  [ROUTES.ABOUT]: Info,
} as const;

const TAB_LABELS: Record<string, string> = {
  [ROUTES.INDUSTRIES]: 'Industries',
  [ROUTES.PRODUCTS]: 'Products',
  [ROUTES.KNOWLEDGE]: 'Knowledge',
  [ROUTES.WORKFLOWS]: 'Workflows',
  [ROUTES.ABOUT]: 'About',
};

function isTabActive(path: string, pathname: string): boolean {
  return pathname === path || pathname.startsWith(path + '/');
}

export function MobileBottomNav() {
  const location = useLocation();

  if (location.pathname === ROUTES.LOGIN) return null;

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-[150] border-t border-[var(--sj-border)] bg-[var(--sj-background)]/95 backdrop-blur-md lg:hidden pb-safe"
      aria-label="Primary"
      data-print-hide
    >
      <div className="mx-auto flex h-14 max-w-lg items-stretch justify-around px-0.5">
        {NAV_ITEMS.map((item) => {
          const Icon = TAB_ICONS[item.path as keyof typeof TAB_ICONS] ?? BookOpen;
          const active = isTabActive(item.path, location.pathname);
          const label = TAB_LABELS[item.path] ?? item.label;

          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                'flex min-w-0 flex-1 flex-col items-center justify-center gap-0.5 touch-manipulation transition-colors',
                active
                  ? 'text-primary-600'
                  : 'text-[var(--sj-text-muted)] active:text-[var(--sj-text-primary)]'
              )}
              aria-current={active ? 'page' : undefined}
            >
              <Icon className={cn('h-5 w-5 shrink-0', active && 'stroke-[2.5]')} aria-hidden />
              <span className="max-w-full truncate px-0.5 text-[10px] font-medium leading-none">
                {label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
